// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AlertController from "./alert_controller"
application.register("alert", AlertController)

import AutosubmitController from "./autosubmit_controller"
application.register("autosubmit", AutosubmitController)

import CharacterCounterController from "./character_counter_controller"
application.register("character-counter", CharacterCounterController)

import ChartController from "./chart_controller"
application.register("chart", ChartController)

import CheckBoxController from "./check_box_controller"
application.register("check-box", CheckBoxController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import ComboboxController from "./combobox_controller"
application.register("combobox", ComboboxController)

import ConditionalDisablementController from "./conditional_disablement_controller"
application.register("conditional-disablement", ConditionalDisablementController)

import ConditionalRequirementController from "./conditional_requirement_controller"
application.register("conditional-requirement", ConditionalRequirementController)

import ConditionalTextController from "./conditional_text_controller"
application.register("conditional-text", ConditionalTextController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import DynamicSelectController from "./dynamic_select_controller"
application.register("dynamic-select", DynamicSelectController)

import FetcherController from "./fetcher_controller"
application.register("fetcher", FetcherController)

import FilterBadgeController from "./filter_badge_controller"
application.register("filter-badge", FilterBadgeController)

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import FlatpickrController from "./flatpickr_controller"
application.register("flatpickr", FlatpickrController)

import FormController from "./form_controller"
application.register("form", FormController)

import FormErrorController from "./form_error_controller"
application.register("form-error", FormErrorController)

import FrameLoaderController from "./frame_loader_controller"
application.register("frame-loader", FrameLoaderController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import HideController from "./hide_controller"
application.register("hide", HideController)

import ImagePreviewController from "./image_preview_controller"
application.register("image-preview", ImagePreviewController)

import InputPreviewController from "./input_preview_controller"
application.register("input-preview", InputPreviewController)

import InputUtilsController from "./input_utils_controller"
application.register("input-utils", InputUtilsController)

import LinkedinReviewController from "./linkedin_review_controller"
application.register("linkedin-review", LinkedinReviewController)

import MasonryController from "./masonry_controller"
application.register("masonry", MasonryController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import ModalTriggerController from "./modal_trigger_controller"
application.register("modal-trigger", ModalTriggerController)

import NestedFormController from "./nested_form_controller"
application.register("nested-form", NestedFormController)

import OpenaiController from "./openai_controller"
application.register("openai", OpenaiController)

import PlacesApiController from "./places_api_controller"
application.register("places-api", PlacesApiController)

import RatingController from "./rating_controller"
application.register("rating", RatingController)

import RequestController from "./request_controller"
application.register("request", RequestController)

import SelectFetcherController from "./select_fetcher_controller"
application.register("select-fetcher", SelectFetcherController)

import SelectFormController from "./select_form_controller"
application.register("select-form", SelectFormController)

import SelectSwitcherController from "./select_switcher_controller"
application.register("select-switcher", SelectSwitcherController)

import ShowMoreController from "./show_more_controller"
application.register("show-more", ShowMoreController)

import SidebarController from "./sidebar_controller"
application.register("sidebar", SidebarController)

import SwitcherController from "./switcher_controller"
application.register("switcher", SwitcherController)

import TabController from "./tab_controller"
application.register("tab", TabController)

import TextFilterController from "./text_filter_controller"
application.register("text-filter", TextFilterController)

import TogglerController from "./toggler_controller"
application.register("toggler", TogglerController)

import TooltipController from "./tooltip_controller"
application.register("tooltip", TooltipController)
